import { render, staticRenderFns } from "./CurrencyRecharge.vue?vue&type=template&id=c232579e&scoped=true&"
import script from "./CurrencyRecharge.vue?vue&type=script&lang=js&"
export * from "./CurrencyRecharge.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyRecharge.vue?vue&type=style&index=0&id=c232579e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c232579e",
  null
  
)

export default component.exports